import * as React from 'react';

import { buildStateProvider } from '@shared-ui/provided-state-context';
import { PropertySaveTripItem } from '@shared-ui/lodging-property-details';
import { ValidatedInputsState } from '@shared-ui/trips-save-item';

import { adaptSearchCriteria } from 'src/common/stores/adapters/bex-api/common/search-criteria-adapter';
import { usePlatformContext } from 'src/common/stores/contexts/platformContext';
import { useSearchCriteriaContext } from 'src/common/stores/contexts';

import { SharedUiWrapperProps, withSharedUiPropertyDetails } from './shared-ui-property-details';

const ValidatedInputsStateProvider = buildStateProvider(new ValidatedInputsState());

const SaveTripItemWrapper: React.FC<SharedUiWrapperProps> = ({ inputs }) => {
  const context = usePlatformContext();
  const searchCriteria = useSearchCriteriaContext();
  const propertySearchCriteria = adaptSearchCriteria(context, searchCriteria);
  const searchCriteriaPrimary = propertySearchCriteria.primary;

  /**
   * Save Trip Item needs to have the latest search criteria so it can correctly save items
   * The searchCriteria in the inputs is cached on pageload and not updated when a user changes dates or rooms
   */

  return (
    <ValidatedInputsStateProvider>
      <PropertySaveTripItem inputs={inputs} searchCriteria={searchCriteriaPrimary} />
    </ValidatedInputsStateProvider>
  );
};

export const SharedUiSaveTripItemWrapper = withSharedUiPropertyDetails(SaveTripItemWrapper);
SaveTripItemWrapper.displayName = 'SharedUiSaveTripItemWrapper';
